let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f7nNi")).then(() => parcelRequire('3MBkB'));